export const environment = {
    production: false,
    firebase: {
        apiKey: "AIzaSyDKV7Jk2jd7Bai-iomLcQ2gEcS8WyMvbKE",
        authDomain: "worksheet-bfda2.firebaseapp.com",
        projectId: "worksheet-bfda2",
        storageBucket: "worksheet-bfda2.appspot.com",
        messagingSenderId: "521884204646",
        appId: "1:521884204646:web:01ad52edebde584942b7a7",
        measurementId: "G-MKZNNG4KX3",
        vapidKey: 'BIB5w5KegXok2nD943aF1F1-clsT6CNDJgekSk1bugp1_XWBN_MA3uJVLYZYE5DYvM42Zwg9Tu8uRHVQFL6u11M'
    },
    // baseURL: 'http://192.168.0.128:8010/worksheet_api/',
    baseURL: 'https://dev.workssheets.co/worksheet_api/',
    domain: 'https://dev.workssheets.co'
};